<kc-chat [conversation]="conversation" [isReadOnly]="true"/>
